import styled from 'styled-components';

export const NextArrowStyle = styled.div`
  border-right: 4px solid #9b9b9b;
  border-bottom: 4px solid #9b9b9b;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.25 : 1)};
  width: 22px;
  height: 22px;
  position: absolute;
  top: 50%;
  right: ${({ dir }) => (dir === 'rtl' ? '' : '-45px')};
  left: ${({ dir }) => (dir === 'rtl' ? '-45px' : '')};
  transform: ${({ dir }) =>
    dir === 'rtl' ? 'rotate(135deg) translateY(0%)' : 'rotate(-45deg) translateY(-50%)'};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;
export const PrevArrowStyle = styled.div`
  border-left: 4px solid #9b9b9b;
  border-bottom: 4px solid #9b9b9b;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.25 : 1)};
  width: 22px;
  height: 22px;
  position: absolute;
  top: 50%;
  left: ${({ dir }) => (dir === 'rtl' ? '' : '-45px')};
  right: ${({ dir }) => (dir === 'rtl' ? '-45px' : '')};
  transform: ${({ dir }) =>
    dir === 'rtl' ? 'rotate(225deg) translateY(0%)' : 'rotate(45deg) translateY(-50%)'};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  z-index: 9;
`;
